import { useEffect } from 'react';

/**
 * Attaches an IntersectionObserver to every .reveal element in the document.
 * When an element enters the viewport it receives the .reveal-visible class,
 * which triggers the CSS transition defined in index.css.
 *
 * Call this hook once inside a page/layout component.
 */
const useReveal = () => {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll('.reveal:not(.reveal-visible)'));
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target); // fire once
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  });
};

export default useReveal;
